import { useCsvUpload } from '../providers';

export interface PreviewComponentProps<T> {
  results: T[];
}

export interface PreviewStepProps<T> {
  PreviewComponent: React.ComponentType<PreviewComponentProps<T>>;
}

export const PreviewStep = <T,>({ PreviewComponent }: PreviewStepProps<T>) => {
  const { results } = useCsvUpload<T, unknown>();

  if (!results) {
    return null;
  }

  return <PreviewComponent results={results} />;
};
